import { Component, Input, OnInit } from '@angular/core';
import { scheduleI, scheduleStatus } from 'app/core/interfaces/schedule';
import * as moment from 'moment';
import { statusSchedule } from 'app/core/data/calendar.json';

@Component({
  selector: 'page-schedule-item',
  templateUrl: './schedule-item.component.html',
  styleUrls: ['./schedule-item.component.scss']
})
export class ScheduleItemComponent implements OnInit {

  @Input() public schedule: any = <any>{}; 
  private status: scheduleStatus[] = statusSchedule;

  constructor() { }

  ngOnInit(): void {
    const schedule = { ...this.schedule }
    if (moment.isMoment(schedule.plannedStartDate)) {
      schedule.dateStart = schedule.plannedStartDate.format('HH:MM');
    }
    this.schedule = schedule;

  }

  isOrganizationDealer(){
    return this.schedule.organization.organization_id == this.schedule.practitioner.practitioner_id 
  }

  timeFormat(date: any) {
    if (!moment.isMoment(date)) {
      date = moment(date);
    }
    return date.format('HH:mm');
  }

  getStatusIcon(schedule: scheduleI) {
    const icon = this.status.find((item:any) => item.id === schedule.status)?.icon;
    return icon ? icon : '';    
  }
  getStatusColor(schedule: any) {
    const color = this.status.find((item:any) => item.id === schedule.status)?.color;


    if (color == 'red') {
      return 'warn';
    }
    if (color == 'grey') {
      return 'accent';
    }
    return '';    
  }

}
